/** Übersetzungen der WhatsApp-Anbindung; eingebunden über lib/i18n/de.ts. */
export const whatsAppDe = {
  qr: {
    contactMismatch: 'Die Telefonnummer gehört nicht zum ausgewählten Kunden oder Ansprechpartner.',
    history: 'WhatsApp-Nachricht',
    accessDenied:
      'Die WhatsApp-Anbindung ist auf diesem Server nicht aktiviert oder es fehlt die Berechtigung.',
    sendFailed:
      'Die Nachricht konnte nicht sicher gesendet werden. Prüfen Sie den Nachrichtenstatus und die Verbindung, bevor Sie erneut senden.',
    documentCustomerMismatch: 'Der Beleg gehört nicht zum Kunden dieser Konversation.',
    templatesUnavailable: 'Cloud-Vorlagen sind für WhatsApp (Baileys) nicht verfügbar.',
    provider: 'WhatsApp (Baileys)',
    providerField: 'Anbindung',
    cloudProvider: 'WhatsApp Business Cloud API',
    label: 'Inoffizielle Verbindung über Baileys',
    help: 'Hilfe zu WhatsApp',
    setup:
      'Verbinden Sie Ihr eigenes WhatsApp-Konto per QR-Code. Textnachrichten an bekannte ERP-Kontakte erscheinen auch dann im Chat, wenn die Unterhaltung am Handy beginnt; Antworten und während einer Unterbrechung empfangene Nachrichten werden ebenfalls übernommen.',
    loadError: 'Der Verbindungsstatus konnte nicht geladen werden.',
    connect: 'Nummer verbinden',
    reconnect: 'Verbindung wiederherstellen',
    logout: 'Abmelden',
    qrAlt: 'QR-Code zur WhatsApp-Verknüpfung',
    scan: 'Öffnen Sie WhatsApp auf Ihrem Telefon → Verknüpfte Geräte → Gerät hinzufügen und scannen Sie diesen QR-Code.',
    expires: 'QR-Code gültig bis {{time}}.',
    expired:
      'Der QR-Code ist abgelaufen. Stellen Sie die Verbindung wieder her, um einen neuen Code zu erhalten.',
    connectionError:
      'Die Verbindung wurde unterbrochen oder konnte nicht hergestellt werden. Stellen Sie die Verbindung erneut her.',
    actionError:
      'Die Aktion ist fehlgeschlagen. Prüfen Sie Ihre Serverfreigabe und versuchen Sie es erneut.',
    limits:
      'Einzelversand mit bewusster Benutzeraktion. Private Chatverläufe und das Adressbuch werden nicht importiert. Einführungsmodus, Einwilligungen und Kontaktsperren gelten weiterhin.',
    logoutTitle: 'WhatsApp-Nummer abmelden?',
    logoutDescription:
      '{{phone}} wird getrennt und die gespeicherte Sitzung gelöscht. Für eine neue Verbindung muss der QR-Code erneut gescannt werden.',
    logoutConfirm: 'Nummer abmelden und Sitzung löschen',
    pdfHint:
      'Der Beleg wird direkt als PDF über WhatsApp (Baileys) gesendet. Cloud-Vorlagen und das 24-Stunden-Fenster gelten hier nicht.',
    pdfSend: 'PDF über WhatsApp senden',
    accepted:
      'Der Versand wurde angenommen. Der Zustellstatus folgt den tatsächlichen WhatsApp-Ereignissen.',
    status: {
      DISCONNECTED: 'Nicht verbunden',
      CONNECTING: 'Verbindung wird aufgebaut',
      QR_READY: 'QR-Code bereit zum Scannen',
      CONNECTED: 'Verbunden',
      EXPIRED: 'QR-Code abgelaufen',
      ERROR: 'Verbindungsfehler',
    },
  },
  inbox: {
    title: 'WhatsApp Team-Inbox',
    subtitle: 'Kundennachrichten und PDF-Belege über die verfügbare WhatsApp-Anbindung.',
    search: 'Name, Nummer oder Nachricht suchen',
    empty: 'Keine Konversationen in dieser Ansicht.',
    error: 'Die Konversationen konnten nicht geladen werden.',
    selectHint: 'Wählen Sie links eine Konversation aus.',
  },
  scope: {
    ALL: 'Alle',
    MINE: 'Meine',
    UNASSIGNED: 'Offen',
    CLOSED: 'Erledigt',
  },
  conversationStatus: {
    OPEN: 'Offen',
    PENDING: 'Wartet',
    RESOLVED: 'Gelöst',
    ARCHIVED: 'Archiviert',
  },
  status: {
    PENDING: 'Wird gesendet',
    SENT: 'Gesendet',
    DELIVERED: 'Zugestellt',
    READ: 'Gelesen',
    FAILED: 'Fehlgeschlagen',
  },
  templateStatus: {
    APPROVED: 'Freigegeben',
    PENDING: 'In Prüfung',
    REJECTED: 'Abgelehnt',
    PAUSED: 'Pausiert',
    DISABLED: 'Deaktiviert',
  },
  category: {
    MARKETING: 'Marketing',
    UTILITY: 'Service',
    AUTHENTICATION: 'Authentifizierung',
  },
  optIn: {
    OPTED_IN: 'Einwilligung liegt vor',
    OPTED_OUT: 'Widerspruch eingelegt',
    PENDING: 'Anfrage läuft',
    NOT_REQUESTED: 'Noch nicht angefragt',
  },
  window: {
    open: 'Fenster offen · {{hours}} h {{minutes}} min',
    openShort: 'Fenster offen ({{hours}} h {{minutes}} min)',
    closed: 'Nur Vorlagen',
    closedShort: 'Fenster geschlossen — nur Vorlagen erlaubt',
  },
  chat: {
    unknownCustomer: 'Kein Kunde zugeordnet',
    openCustomer: 'Kundenprofil',
    assignee: 'Zuständig',
    unassigned: 'Nicht zugewiesen',
    status: 'Status',
    empty: 'Noch keine Nachrichten in dieser Konversation.',
    error: 'Der Nachrichtenverlauf konnte nicht geladen werden.',
    placeholder: 'Nachricht schreiben … (Enter sendet, Umschalt+Enter für neue Zeile)',
    send: 'Senden',
    emoji: 'Emoji einfügen',
    attachDocument: 'Beleg anhängen',
    useTemplate: 'Vorlage verwenden',
    download: 'Herunterladen',
    attachment: 'Anhang',
    templateLabel: 'Vorlage: {{name}}',
    windowClosed:
      '24h-Fenster abgelaufen. Bitte eine Vorlage (Template) versenden, um die Konversation wieder zu öffnen.',
    chooseTemplate: 'Vorlage auswählen',
  },
  sidebar: {
    title: 'Kundenakte',
    placeholder: 'Wählen Sie eine Konversation, um die Kundendaten zu sehen.',
    noCustomer: 'Diese Nummer ist keinem Kunden zugeordnet.',
    contact: 'Ansprechpartner: {{name}}',
    optIn: 'WhatsApp Opt-in bestätigt',
    optInSaved: 'Einwilligung gespeichert.',
    openDocuments: 'Offene Belege',
    noDocuments: 'Keine offenen Belege.',
    documentsError: 'Die Belege konnten nicht geladen werden.',
  },
  templates: {
    pickTitle: 'Vorlage versenden',
    pickDescription:
      'Nur von Meta freigegebene Vorlagen können außerhalb des 24-Stunden-Fensters zugestellt werden.',
    template: 'Vorlage',
    choose: 'Vorlage wählen',
    placeholder: 'Platzhalter {{position}}',
    preview: 'Vorschau',
    pdfHeader: 'Beleg-PDF als Kopfzeile',
    send: 'Vorlage senden',
    sent: 'Die Vorlage wurde versendet.',
    error: 'Die Vorlagen konnten nicht geladen werden.',
    emptyApproved: 'Es ist keine freigegebene Vorlage vorhanden.',
  },
  document: {
    title: 'Beleg anhängen',
    description: 'Der Beleg wird als PDF an die laufende Konversation gesendet.',
    document: 'Beleg',
    choose: 'Beleg wählen',
    caption: 'Begleittext',
    captionPlaceholder: 'Optionaler Text zum Anhang',
    send: 'Beleg senden',
    sent: 'Der Beleg wurde versendet.',
    empty: 'Für diesen Kunden liegt kein Beleg vor.',
    error: 'Die Belege konnten nicht geladen werden.',
  },
  documentSend: {
    chooseConversation: 'Konversation wählen',
    action: 'Per WhatsApp senden',
    title: 'Beleg per WhatsApp senden',
    description: 'Beleg {{number}} an {{customer}} übermitteln.',
    noConversation: 'Für diesen Kunden besteht noch keine Konversation.',
    createChat: 'Konversation anlegen',
    windowOpenHint: 'Das Servicefenster ist offen; die Vorlage stellt den Beleg mit PDF zu.',
    windowClosedHint:
      'Das Servicefenster ist geschlossen. Der Versand erfolgt über eine freigegebene Vorlage.',
    chooseTemplate: 'Vorlage wählen & senden',
  },
  customerTab: {
    subtitle:
      'Gespeicherte WhatsApp-Konversationen dieses Kunden. Angezeigt werden nur Konten, denen Sie zugeordnet sind.',
    start: 'Neue Konversation',
    startTitle: 'Konversation per WhatsApp starten',
    startDescription: 'Die Nummer wird automatisch ins Format E.164 überführt.',
    started: 'Die Konversation wurde angelegt.',
    phone: 'Mobilnummer',
    empty: 'Für diesen Kunden besteht noch keine WhatsApp-Konversation.',
    error: 'Die Konversationen konnten nicht geladen werden.',
    noAccess: 'Für den WhatsApp-Verlauf fehlt die Berechtigung.',
  },
  config: {
    title: 'WhatsApp-Konfiguration',
    subtitle: 'WhatsApp-Anbindungen und Cloud-Vorlagen verwalten.',
    error: 'Die Konfiguration konnte nicht geladen werden.',
    tabConnection: 'WhatsApp Business Cloud API',
    tabTemplates: 'Cloud-Vorlagen',
    credentials: 'Meta Graph API',
    credentialsHint:
      'Die Angaben stammen aus dem Meta Developer Dashboard. Geheimnisse werden verschlüsselt gespeichert und nie zurückgegeben.',
    phoneNumberId: 'Phone Number ID',
    wabaId: 'WhatsApp Business Account ID',
    appId: 'App ID',
    businessPhoneNumber: 'Absendernummer (E.164)',
    displayName: 'Anzeigename',
    accessToken: 'Permanent Access Token',
    appSecret: 'App Secret',
    secretPlaceholder: 'Nur ausfüllen, um den Wert zu ersetzen',
    secretSet: 'Hinterlegt ({{hint}})',
    secretMissing: 'Noch nicht hinterlegt',
    rotateToken: 'Verify Token neu erzeugen',
    rotateTokenHint: 'Erfordert eine erneute Einrichtung des Webhooks im Meta-Dashboard.',
    saved: 'Die Konfiguration wurde gespeichert.',
    test: 'Verbindung testen',
    verifiedName: 'Verifizierter Name',
    displayNumber: 'Angezeigte Nummer',
    quality: 'Qualität',
    limit: 'Versandlimit',
    checkedAt: 'Geprüft am {{timestamp}}',
    webhook: 'Webhook-Einrichtung',
    webhookHint:
      'Diese Werte im Meta Developer Dashboard unter „Webhooks" hinterlegen und das Feld „messages" abonnieren.',
    callbackUrl: 'Callback-URL',
    verifyToken: 'Verify Token',
    copy: 'Kopieren',
    copied: 'In die Zwischenablage kopiert.',
    lastWebhook: 'Letzte Zustellung: {{timestamp}}',
    noWebhookYet: 'Es wurde noch keine Zustellung empfangen.',
    templates: 'Vorlagen von Meta',
    templatesHint: 'Der lokale Spiegel wird beim Abgleich vollständig aktualisiert.',
    templatesEmpty: 'Es wurden noch keine Vorlagen synchronisiert.',
    sync: 'Vorlagen synchronisieren',
    syncDone: '{{fetched}} Vorlagen abgerufen · {{created}} neu · {{updated}} aktualisiert.',
    templateName: 'Name',
    language: 'Sprache',
    category: 'Kategorie',
    status: 'Status',
    templatePreview: 'Vorschau mit ERP-Platzhaltern',
  },
  accounts: {
    unavailableMember: 'Nicht mehr verfügbarer Mitarbeitender ({{id}})',
    unavailableHelp:
      'Diese gespeicherten Zuordnungen betreffen nicht mehr verfügbare Mitarbeitende. Entfernen Sie sie ausdrücklich, wenn sie aufgehoben werden sollen. Es wird keine Zuordnung automatisch entfernt.',

    title: 'WhatsApp-Konten',
    description:
      'Jedes Konto hat eine eigene Verbindung. Nur zugeordnete Mitarbeitende können seine Chats und seinen QR-Code sehen.',
    select: 'WhatsApp-Konto',
    choose: 'Konto wählen',
    all: 'Alle zugeordneten Konten',
    empty: 'Ihnen ist kein WhatsApp-Konto zugeordnet.',
    error: 'Die WhatsApp-Konten konnten nicht geladen werden.',
    new: 'Konto anlegen',
    edit: 'Konto bearbeiten',
    label: 'Kontobezeichnung',
    members: 'Zugeordnete Mitarbeitende',
    noMembers: 'Ohne Zuordnung kann niemand dieses Konto verwenden.',
    manageEmpty: 'Es ist noch kein WhatsApp-Konto angelegt.',
    saved: 'Das WhatsApp-Konto wurde gespeichert.',
    saveError:
      'Das Konto konnte nicht gespeichert werden. Prüfen Sie die Angaben und versuchen Sie es erneut.',
    rescan: 'Die Verknüpfung wurde aufgehoben. Scannen Sie einen neuen QR-Code.',
    membersError: 'Die Mitarbeitenden konnten nicht geladen werden.',
    invalid: 'Prüfen Sie die Kontobezeichnung und die Mitarbeitendenauswahl.',
  },
  history: {
    connect: 'Verbinden und Verlauf laden',
    connectTitle: '{{account}} mit Textverlauf verknüpfen?',
    connectDescription:
      'Wählen Sie diese Aktion vor dem ersten QR-Scan, um verfügbaren Textverlauf beim Verknüpfen anzufordern. Eine bestehende Verknüpfung wird nicht automatisch abgemeldet.',
    connectConfirm: 'Mit Textverlauf verknüpfen',
    pairingRequired:
      'Für diese Verknüpfung fehlen geeignete ERP-Nachrichten als Ausgangspunkt. Melden Sie das Konto bewusst ab und wählen Sie anschließend „Verbinden und Verlauf laden“, bevor Sie den neuen QR-Code scannen. Normales Wiederverbinden lädt diesen Verlauf nicht nach.',

    action: 'Verlauf anfordern',
    title: 'Verlauf für {{account}} anfordern?',
    description:
      'Fordert verfügbare Textnachrichten vom verknüpften Gerät an. Es werden ausschließlich bekannte ERP-Kunden und Ansprechpartner oder ausdrücklich zugeordnete Kontochats übernommen. Ältere Nachrichten werden abschnittsweise nachgeladen: je Anfrage bis zu 200 Chats, 1.000 Nachrichten je Chat und zehn Minuten. Bei längeren Verläufen erneut anfordern. WhatsApp bestimmt die Verfügbarkeit; eine vollständige Übernahme ist nicht garantiert.',
    confirm: 'Verlauf bewusst anfordern',
    pending: 'Der Verlauf wird angefordert …',
    requested:
      'Die Anfrage wurde übermittelt. Verfügbare Textnachrichten bekannter ERP-Kontakte erscheinen nach der Verarbeitung.',
    unavailable: 'Das verknüpfte Gerät stellt derzeit keinen Verlauf zur Verfügung.',
    error:
      'Der Verlauf konnte nicht angefordert werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
  },
  phone: {
    change: 'Nummer ändern',
    changeTitle: 'WhatsApp-Nummer ändern',
    changeDescription:
      'Die neue Nummer erhält eine eigene Konversation beim gewählten WhatsApp-Konto. Der bisherige Verlauf bleibt erhalten. Die Kundendaten werden nicht automatisch geändert.',
    useNumber: 'Neue Nummer verwenden',

    existing: 'Vorhandene Nummer',
    choose: 'Kunden- oder Kontaktnummer wählen',
    invalid: 'Geben Sie eine gültige Mobilnummer ein, z. B. 0170 1234567 oder +49 170 1234567.',
    loadError: 'Die vorhandenen Telefonnummern konnten nicht geladen werden.',
    source: {
      CUSTOMER: 'Kundennummer',
      CONTACT_MOBILE: 'Kontakt: Mobilnummer',
      CONTACT_PHONE: 'Kontakt: Telefonnummer',
    },
  },
  baileysTemplates: {
    title: 'Lokale WhatsApp-Vorlagen',
    description:
      'Wiederverwendbare Texte für Baileys-Konten. Lokale Vorlagen benötigen keine Meta-Freigabe und beachten die üblichen Kontaktpräferenzen.',
    create: 'Lokale Vorlage anlegen',
    edit: 'Lokale Vorlage bearbeiten',
    delete: 'Lokale Vorlage löschen',
    confirmDeleteTitle: '{{name}} löschen?',
    confirmDeleteDescription:
      'Diese lokale Vorlage steht für neue Nachrichten nicht mehr zur Verfügung. Bestehende Nachrichten bleiben erhalten.',
    empty: 'Es wurden noch keine lokalen Vorlagen angelegt.',
    loadError: 'Die lokalen Vorlagen konnten nicht geladen werden.',
    name: 'Vorlagenname',
    language: 'Sprache',
    body: 'Nachrichtentext',
    bodyHelp:
      'Nummerierte Platzhalter wie {{example}} verwenden. Bei 1 beginnen, ohne Lücken; höchstens 50 verschiedene Platzhalter und 4.096 Zeichen.',
    variableMapping: 'Optionale ERP-Werte',
    mappingSource: 'Wertquelle {{position}}',
    mappingLabel: 'Feldbezeichnung {{position}}',
    noMapping: 'Manuell eingeben',
    transactionalOnly:
      'Für geschäftsbezogene Nachrichten. Werbung erfordert den getrennten Marketingprozess mit dokumentierter Einwilligung.',
    saved: 'Die lokale Vorlage wurde gespeichert.',
    deleted: 'Die lokale Vorlage wurde gelöscht.',
    versionConflict:
      'Diese Vorlage wurde zwischenzeitlich geändert. Vor dem Speichern oder Senden neu laden.',
    duplicateName: 'Eine lokale Vorlage mit diesem Namen und dieser Sprache ist bereits vorhanden.',
    invalidPlaceholders:
      'Nur nummerierte Platzhalter von 1 bis 50 ohne Lücken verwenden, zum Beispiel {{example}}.',
    invalidMapping: 'Jeden ERP-Wert nur einmal und nur einem vorhandenen Platzhalter zuordnen.',
    invalidParameters:
      'Jeden Platzhalter genau einmal mit einem gültigen Wert ausfüllen. Die Nachrichtenlänge prüfen.',
    invalidName: 'Einen Vorlagennamen mit höchstens 120 Zeichen eingeben.',
    invalidLanguage: 'Eine unterstützte Sprache auswählen.',
    invalidBody: 'Eine Nachricht mit höchstens 4.096 Zeichen eingeben.',
    validationSummary: 'Die Vorlage konnte nicht gespeichert werden. Die markierten Felder prüfen.',
    discardTitle: 'Änderungen verwerfen?',
    discardDescription: 'Die ungespeicherten Änderungen an dieser Vorlage gehen verloren.',
    discard: 'Änderungen verwerfen',
    pickTitle: 'Lokale WhatsApp-Vorlage senden',
    pickDescription:
      'Text und alle Werte vor dem Versand über das ausgewählte Baileys-Konto prüfen.',
    choose: 'Lokale Vorlage auswählen',
    send: 'Nachricht senden',
    preview: 'Nachrichtenvorschau',
    pdfAttachment: 'PDF angehängt',
    search: 'Lokale Vorlagen suchen',
    page: 'Seite {{page}} von {{pages}}',
    captionTooLong: 'Eine Nachricht zusammen mit einem PDF darf höchstens 1.024 Zeichen enthalten.',
    sources: {
      'customer.name': 'Kundenname',
      'customer.number': 'Kundennummer',
      'contact.firstName': 'Vorname der Kontaktperson',
      'document.number': 'Belegnummer',
      'document.date': 'Belegdatum',
      'document.dueDate': 'Fälligkeitsdatum',
      'document.grossTotal': 'Bruttobetrag',
      'document.currency': 'Währung',
      'tenant.name': 'Firmenname',
      'user.name': 'Mitarbeitername',
      custom: 'Manueller Wert',
    },
  },
};
